module.exports = __webpack_public_path__ + "img/901471235.f91b92cf.png";